<div class="modal-body">
  <div class="right-name">
      <!-- <div class="item">Наименование блока</div> -->
      <div class="item">Номер блока</div>
  </div>
  <div class="left-text">
      <!-- <div class="item"><input type="text" [(ngModel)]="block.title"></div> -->
      <div class="item"><input type="text" [(ngModel)]="block.blockNumber"></div>
  </div>
</div>
<div class="modal-btns">
  <div class="btn btn-accept" (click)="addBlock()">Подтвердить</div>
  <div class="btn btn-cancel" (click)="cancel()">Отменить</div>
</div>